import React, { useState, useEffect, useRef } from 'react';
// import './CustomDropdown.css';

const CustomDropdown = ({ options, selectedOption, onChange, label, searchable, placeholder, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState(''); // Search term can be string or number
  const [filteredOptions, setFilteredOptions] = useState(options);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    if (!disabled) {
      setIsOpen((prevState) => !prevState);
      setSearchTerm(''); // Clear search when dropdown is toggled
      setFilteredOptions(options); // Reset options when dropdown is toggled
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value ? e.target.value.toString().toLowerCase() : ''; // Safely handle undefined
    setSearchTerm(e.target.value);

    setFilteredOptions(
      options.filter((option) => {
        const optionName = option ? option.toString().toLowerCase() : ''; // Safely handle undefined
        return optionName.includes(term);
      })
    );
  };

  const handleSelectOption = (option) => {
    if (!disabled && !option.disabled) {
      onChange(option === null ? null : option); // Handle valid selection
      setIsOpen(false); // Close dropdown after selection
    }
  };

  // Close the dropdown when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false); // Close dropdown if clicked outside
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="custom-dropdown-b" ref={dropdownRef}>
      <div className="dropdown-container-b" onClick={toggleDropdown}>
        <div className="selected-option">
          {selectedOption ? selectedOption : placeholder || 'Select an option'}
        </div>
        <div className={`arrow ${isOpen ? 'open' : ''}`}>&#x25BC;</div>
      </div>

      {isOpen && (
        <div className="options-list">
          {searchable && (
            <input
              type="text"
              className="search-input"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearch}
              disabled={disabled}
            />
          )}
          {/* {placeholder && (
            <div className="option placeholder-option disabled">
              {placeholder}
            </div>
          )} */}
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <div
                key={typeof option === 'string' ? option : option.id || option}
                className="option"
                onClick={() => handleSelectOption(option)}
              >
                {typeof option === 'string' ? option : option.name || option}
              </div>
            ))
          ) : (
            <div className="no-options">No options found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
